import '@sass/theme.scss';
import CwLoadModules from '@customjs/module-loader.js';
import CwThemeFramework from '@customjs/generalFns.js';
import { MatchHeight } from 'js-match-height';

/**
 * Running mixed functions across the theme
 */
CwThemeFramework.generalFns();

/**
 * Bootstrap Tabs
 */
const tabs = document.querySelector('[role="tablist"]');

if (tabs) CwLoadModules.Tabs();

/**
 * Dropdown
 */
const dropdown = document.querySelector('.dropdown-toggle');

if (dropdown) CwLoadModules.Dropdown();

/**
 * Accordions
 */
const accordion = document.querySelector('.accordion');

if (accordion) CwLoadModules.Collapse();

/**
 * Service Worker
 */

// check if service worker is available

if ('serviceWorkerNO' in navigator) {
  document.addEventListener('DOMContentLoaded', () => {
    // Registering Service Worker
    navigator.serviceWorker
      // eslint-disable-next-line no-undef
      .register(`${childThemeURL}/sw.php`, {
        scope: '/',
      })
      .then((reg) => console.log(reg.scope))
      .catch((error) => console.log(error.message));
  });
}

/**
 * Loading Mobile Menu
 */

function matchMobile() {
  const mobileMediaQuery = window.matchMedia('(max-width: 991px)');
  return mobileMediaQuery.matches;
}

matchMobile() ? CwThemeFramework.mobileMenu() : '';

window.addEventListener('resize', () => {
  matchMobile() ? CwThemeFramework.mobileMenu() : '';
});

/**
 * Loading Modals in the Page
 * We will be pulling all the buttons with the data-cw-target
 * Attribute in order to initialize all the modals.
 */

// Checking for all out buttons
const modals = document.querySelectorAll('[data-cw-target]');
if (modals.length) {
  const modalInstances = [];
  CwLoadModules.modals().then((CwModals) => {
    modals.forEach((modalBtn, index) => {
      modalInstances[index] = new CwModals('.cw-modal');
      modalInstances[index].init();
    });
  });
}

// <h3> replacements on the [qa] plugin
const faqsTitle = document.querySelectorAll('.qa-faq-title');
if (faqsTitle.length) {
  faqsTitle.forEach((title) => {
    title.outerHTML = title.outerHTML.replace("h3", "div");
  });
} 

// fix for the [faq] plugin
document.addEventListener(
  'click',
  (e) => {
   
    if (e.target.classList.contains('qa-faq-anchor')) {
      
      const anchorLink = e.target;
      e.preventDefault();
      if (anchorLink.classList.contains('active')) {
        anchorLink.classList.remove('active');
        anchorLink.parentNode.classList.remove('open');
      } else {
        const currentActiveElement = anchorLink
          .closest('.qa-category')
          .querySelector('.active');
        if (currentActiveElement)
          currentActiveElement.classList.remove('active');
        
        const faqAnchors = document.querySelectorAll('.qa-faq-anchor');
        faqAnchors.forEach((faqAnchor) => {
          faqAnchor.classList.remove('active');
          faqAnchor.parentNode.classList.remove('open');
        });

        anchorLink.classList.add('active');
        anchorLink.parentNode.classList.add('open');
      }
    }
  },  
);


// Adding active to FAQ accordion [faq] plugin 
var qaFaqList = document.getElementsByClassName("qa-faq-anchor");
var addActive = function() {
  
  const faqAnchors = document.querySelectorAll('.qa-faq-anchor');
   faqAnchors.forEach((faqAnchor) => {
          faqAnchor.classList.remove('active');
          faqAnchor.parentNode.classList.remove('open');
  });
  this.classList.add('active');

};

for (var i = 0; i < qaFaqList.length; i++) {
  qaFaqList[i].addEventListener('click', addActive, false);
}
// end Adding active to FAQ accordion [faq] plugin

/**
 * Table of Contents
 * Shortcode [toc]
 */

const toc = document.getElementById('toc');
console.log('toc initializing ' + toc);
if (toc && acf_col_vars) {
  CwLoadModules.TableofContents().then((CwTableOfContents) => {
      const cwTOC = new CwTableOfContents();
      cwTOC.createTOC();
      cwTOC.columnLayout();
      cwTOC.tocWidth();
  });
}

/**
 * Loading Swiper JS 
 * https://swiperjs.com/
 */
const carouselModules = {
  'pa-slider': 'pa-carousel',
  'attorney-slider': 'team-carousel',
  'results-slider': 'results-carousel',
  'results-slider-sidebar': 'results-slider-sidebar',
  'awards-wrap': 'awards-carousel',
  'awards-wrap-sidebar': 'awards-carousel-sidebar',
  'testimonials-section-slider': 'testimonials-carousel',
  'grid-attorney': 'team-carousel',
  'grid-videos': 'videos-carousel',
  'our-team': 'team-sidebar-widget',
};

// eslint-disable-next-line no-restricted-syntax
for (const [key, value] of Object.entries(carouselModules)) {
  const name = document.getElementById(key);
  if (name) {
    CwLoadModules.swiperSliders(value).then((module) => {
      module.default();
    });
  }
}

/**
 * Loading MatchHeight
 * Create new instance of MatchHeight [new MatchHeight()]
 * for elements that need to have the same height
 * https://www.npmjs.com/package/js-match-height
 */

const testimonialItem = new MatchHeight('.testimonials-section__item');
const whychooseusItem = new MatchHeight('.why-choose-us__item');

/**
 * Smooth Scroll
 * add class '.scroll' to new elements
 * class '.scroll' already added to footer back to top and TOC dynamic link elements
 */
// smooth scroll
document.addEventListener(
  'click',
  (event) => {
    if (!event.target.closest('.scroll')) return;

    const hashValue = event.target.closest('.scroll').getAttribute('href');
    const target = document.querySelector(hashValue);

    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
    history.pushState(null, null, hashValue);
    event.preventDefault();
  },
  false
);

const backToTopButton = document.querySelector(".btn-back");
if(backToTopButton) {
    backToTopButton.addEventListener('click', 
    (event) => {
        document.body.scrollTo({top: 0, behavior: 'smooth'});
    },
    false
    );
}

// //CwThemeFramework.removeEmptyTOCs();
// window.addEventListener('resize', function(event) {
//   //CwThemeFramework.removeEmptyTOCs();
//   console.log('test');
// }, true);



